import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    url: String,     // PATCH URL for the task
    field: String,   // field name (e.g. "title", "context_note", "due_date")
    current: String  // current value
  }

  static targets = ["display", "input"]

  edit() {
    this.displayTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.focus()
    if (this.inputTarget.tagName !== "TEXTAREA") {
      this.inputTarget.select()
    }
  }

  save() {
    const newValue = this.inputTarget.value
    if (newValue === this.currentValue) {
      this.cancel()
      return
    }

    const formData = new FormData()
    formData.append(`command_centre_task[${this.fieldValue}]`, newValue)

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: formData
    }).then(response => {
      if (response.ok) {
        return response.text()
      }
    }).then(html => {
      if (html) {
        Turbo.renderStreamMessage(html)
      }
    }).catch(() => {
      this.cancel()
    })
  }

  cancel() {
    this.inputTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
    this.inputTarget.value = this.currentValue
  }

  autoSave() {
    if (this._autoSaveTimer) clearTimeout(this._autoSaveTimer)
    this._autoSaveTimer = setTimeout(() => {
      this.save()
    }, 800)
  }

  disconnect() {
    if (this._autoSaveTimer) clearTimeout(this._autoSaveTimer)
  }

  onKeydown(event) {
    if (event.key === 'Enter' && this.inputTarget.tagName !== "TEXTAREA") {
      event.preventDefault()
      this.save()
    }
    if (event.key === 'Escape') {
      this.cancel()
    }
  }
}
